import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Popover } from 'wix-ui-tpa';
import { useTranslation } from '@wix/yoshi-flow-editor';

import AccountInfo from '../account-info/account-info';
import Icon from '../../../icon/icon';

import styles from './account-button-with-tooltip.scss';
import { st, classes } from './popover.st.css';

interface AccountButtonWithTooltipProps {
  className: string;
  logoutLabel: string;
  userEmail: string;
  onLogoutClick: () => void;
}
const AccountButtonWithTooltip: React.FC<AccountButtonWithTooltipProps> = (
  props,
) => {
  const { t } = useTranslation();
  const { logoutLabel, userEmail, onLogoutClick, className } = props;
  const [shown, setShown] = React.useState(false);
  const show = () => setShown(true);
  const hide = () => setShown(false);
  return (
    <Popover
      hideDelay={300}
      shown={shown}
      placement="bottom"
      wiredToSiteColors={false}
      className={st(classes.root)}
      contentClassName={styles.popout}
      data-hook="channel-account-info"
    >
      <Popover.Element>
        <button
          className={classnames(styles['account-info-button'], className)}
          aria-label={t('widget.accessibility.my-account')}
          onClick={shown ? hide : show}
          onBlur={hide}
          onMouseEnter={show}
          onMouseLeave={hide}
        >
          <Icon name="avatar" />
        </button>
      </Popover.Element>
      <Popover.Content>
        <div
          onFocus={show}
          onBlur={hide}
          onMouseEnter={show}
          onMouseLeave={hide}
        >
          <AccountInfo
            logoutLabel={logoutLabel}
            userEmail={userEmail}
            onLogoutClick={onLogoutClick}
          />
        </div>
      </Popover.Content>
    </Popover>
  );
};

export default AccountButtonWithTooltip;
